import {createStore, compose, applyMiddleware} from 'redux';
import logger from 'redux-logger'; //helps with debugging.
import { thunk } from 'redux-thunk';
import { persistStore } from 'redux-persist'; //cache our store in the browser

import rootReducer from './root-reducer';

const middlewares = [thunk] //middlewares  are passed in as an array. If you want to pass in more middlewares, just add it to the array.
let storeDevelopment = null

if (import.meta.env.DEV) { //only have redux logger work on dev environment
    middlewares.push(logger);
    const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    storeDevelopment = createStore(rootReducer, composeEnhancer(applyMiddleware(...middlewares)))
}

export const store = import.meta.env.DEV ? storeDevelopment : createStore(rootReducer, applyMiddleware(...middlewares));

export const persistor = persistStore(store); 